export type { InitialProps } from './props';
export { getInitialProps } from './props';
